import { render, staticRenderFns } from "./LoginRegistrationBlock.vue?vue&type=template&id=07980d8b&"
import script from "./LoginRegistrationBlock.vue?vue&type=script&lang=js&"
export * from "./LoginRegistrationBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports